<div class="modal-header">
    <div class="row w-100">
        <div class="col-md-11">
            <h4 class="modal-title">{{ title }}</h4>
        </div>
        <div class="col-md-1 pe-0">
            <button type="button" class="close float-end text-white" aria-label="Close"
                data-testid="shared.confirmation-dialog.close-btn"
                (click)="dismiss()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</div>
<div class="modal-body" [innerHtml]="message"></div>
<div class="modal-footer">
    <button type="button" class="btn" (click)="decline()"
        data-testid="shared.confirmation-dialog.cancel-btn">
        {{ btnCancelText }}
    </button>
    <button type="button" class="btn btn-primary rounded-pill ps-3 pe-3" (click)="accept()"
        data-testid="shared.confirmation-dialog.confirm-btn">
        {{ btnOkText }}
    </button>
</div>
